<template>
  <div class="goods-box-one-wrapper-box">
    <div class="goods-box-one-wrapper">
      <div class="justify-align">
        <div>
          <div class="title-box" style="display: inline-block;margin-right: 2vw;" @click="goOneList">
            <div class="title-txt">{{param.title}}</div>
            <div class="title-box-line"></div>
          </div>
          <div style="display: inline-block" v-if="showStatus == 1">
            <div class="down-time" v-if="msTxtShow==false"><span>{{showTime.H}}</span>：<span>{{showTime.M}}</span> ：<span>{{showTime.S}}</span></div>
            <div  class="down-time" style="color: #F23926;font-weight: bold;" v-else>秒杀中</div>
          </div>
        </div>
        <div class="left-justifying f-title-right" v-if="showStatus ==1">
          <img :src="require('../../assets/'+appTheme+'/z_icon.png')" alt="" /><div> <span>{{fullTime}}</span> 开抢</div>
        </div>
        <div v-if="showStatus == 0" style="color: #A1A0A0;font-size: 3.2vw;" @click="goOneList">更多></div>
      </div>
      <div class="goods-box-one" v-if="reRender">
        <swiper class="swiper" :options="swiperOptionTwoGoods">
          <swiper-slide v-for="(item,index) in param.data" :key="index" :index="index" :data-index='index'>
            <div class="itme-box">
              <img class="img-goods" :src="item.image" alt="" :data-id="item.id" :data-goodsid="item.goods_id" :data-usefulstock="item.useful_stock" />
              <div class="price-box">
                <div class="price-df" :data-id="item.id" :data-goodsid="item.goods_id" :data-usefulstock="item.useful_stock" :style="{color: (index == 0 ?'#F23926':'#999')}">￥{{item.price}}</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="reRender" v-else>
        <div class="itme-box" v-for="(item,index) in param.data" :key="index" :index="index" :data-index='index'>
          <img class="img-goods" :src="item.image" alt="" :data-id="item.id" :data-goodsid="item.goods_id" :data-usefulstock="item.useful_stock" />
          <div class="price-box">
            <div class="price-df" :data-id="item.id" :data-goodsid="item.goods_id" :data-usefulstock="item.useful_stock" :style="{color: (index == 0 ?'#F23926':'#999')}">￥{{item.price}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Swiper2, {Navigation, Pagination, Autoplay} from 'swiper';
Swiper2.use([Navigation, Pagination, Autoplay]);
var vm = null
export default {
  name: "minitOnePayItem",
  props: { // ['param','fullTime','showStatus','showTime', 'msTxtShow'],
    param:{
      type: Object,
      required:false // 定义该 prop 是否是必填项
    },
    fullTime: {
      type: String,
      required:false // 定义该 prop 是否是必填项
    },
    showTime: {
      type: Object,
      required:false // 定义该 prop 是否是必填项
    },
    msTxtShow: Boolean,
    showStatus: Number
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data(){
    return{
      appTheme:this.$store.state.appTheme,
      swiperOptionTwoGoods: {},
      swiperOptions: {
        slidesPerView: 4, // 同时显示的slides数量
        spaceBetween: 8,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        longSwipesRatio : 0.1,
        loop:true,
        observer: true,
        autoplay: {
          disableOnInteraction: false,
          stopOnLastSlide: true,
          // delay:1000
        },
        // autoplayDisableOnInteraction : true,   // 用户操作swiper之后，是否禁止autoplay
        speed: 800, // // 切换图片速度
        on: {
          click: function(swiper,event){
            // console.log('你碰了Swiper',event.target);
            let id = event.target.getAttribute('data-id')
            let goods_id = event.target.getAttribute('data-goodsid') // // 商品id
            let useful_stock = event.target.getAttribute('data-usefulstock') // 是否秒杀有库存
            // console.log('id',id)
            vm.goDesGood(id,goods_id,useful_stock)
          },
        },

      },
      reRender:true
    }
  },
  activated(){
    // console.log('msTxtShowactivated')
    this.reRender = false;
    setTimeout(() => {
      this.reRender = true;
      // this.initSwiper()
    }, 100);
  },
  created() {
    // this.full_time = this.param.data[0].tips_time
    // console.log(this.showTime);//5
    // console.log('showStatus',this.showStatus)
    // console.log('fullTime',this.fullTime)
    console.log('msTxtShow',this.msTxtShow)
    vm = this
    this.initSwiper()
  },
  methods: {
    initSwiper: function() {
      this.swiperOptionTwoGoods = this.swiperOptions;
    },
    goDesGood(id,goods_id,useful_stock){

      console.log('go',id,goods_id,useful_stock)
      // tid 一元购商品项目id  onepay_goods[].id
      let pro_id = id // 项目id
      if (this.msTxtShow ==true && useful_stock != 0){ // 一元秒杀中
        this.$router.push({path:'/goodDetails',query:{id:goods_id,type:pro_id,isPay:useful_stock}})
      } else {
        this.$router.push({path:'/goodDetails',query:{id:goods_id}})
      }
    },
    goOneList(){
      this.$router.push('/oneYuan')
    },
  }
}
</script>

<style lang="scss" scoped>
.goods-box-one-wrapper-box{
  margin: 0 26px;
}
.reRender {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 0.13333rem;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  .itme-box{
    font-size: 24px;color: #AEAEAE;display: inline-block;margin-right: 20px; width: 150px;
    img{
      width: 150px;
      height: 124px;display: block;margin: 0 auto;
    }
  }
}
.down-time{
  display: inline-block;
  span{
    background: #F23926;color: #ffffff;
    border-radius: 8px;display: inline-block;padding: 2px 10px;font-size: 24px;
  }
}
.title-box{
  display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
  position: relative;padding: 22px 0 5px;margin-bottom: 20px;
  .title-txt{
    width: 143px;text-align: center;
  }
  .title-box-line{
    width: 143px;
    height: 15px;
    background: #FEDC32;
    border-radius: 8px;margin-top: -15px;
  }
}
.f-title-right{
  font-weight: bold;
  color: #282828;font-size: 22px;
  span{
    color: #F23926;
  }
  img{
    margin-right: 10px;height: auto;display: block;width: 22px;
  }
}
.goods-box-one-wrapper{
  padding: 0 10px 10px;overflow: hidden;background: #fff;border-radius: 8px;
  margin-bottom: 30px;
  .goods-box-one{
    .itme-box{
      overflow: hidden;
      .img-goods{
        width: 150px;
        height: 150px;
      }
      .price-box{
        text-align: center;padding-bottom: 20px;padding-top: 20px;
      }
      .price-df{
        font-weight: bold;
        color: #F23926;
        line-height: 28px;font-size: 30px;
      }
    }
    //margin-bottom: 130px;
  }
}


</style>
